import React, { useContext, useEffect } from 'react'
import useFetch, { CachePolicies } from 'use-http'
import type { CmFieldResponseObject } from '../interfaces'
import { PublicLinksInfoContext } from './PublicLinksInfoProvider'

interface ContextProps {
  cmFields: CmFieldResponseObject[]
  loading: boolean
  refetch(): Promise<CmFieldResponseObject[]> | Promise<void>
}

export const CustomMetadataContext = React.createContext<ContextProps>({
  cmFields: [],
  loading: false,
  refetch: () => Promise.resolve(),
})

export function CustomMetadataProvider({
  children,
}: {
  children: React.ReactElement
}): React.ReactElement {
  const { isPublicLink } = useContext(PublicLinksInfoContext)

  const { data, loading, request, get } = useFetch<CmFieldResponseObject[]>(
    '/api/v1/customMetadataFields',
    {
      cachePolicy: CachePolicies.NO_CACHE,
      data: undefined,
    },
  )
  const fetchCustomMetadata = async (): Promise<void> => {
    await get()
  }

  useEffect(() => {
    if (!isPublicLink && !data) {
      void fetchCustomMetadata()
    }
  }, [data, isPublicLink])

  if (request.error) {
    return (
      <CustomMetadataContext.Provider
        value={{ loading, cmFields: [], refetch: fetchCustomMetadata }}
      >
        {children}
      </CustomMetadataContext.Provider>
    )
  }

  return (
    <CustomMetadataContext.Provider
      value={{
        loading,
        cmFields: !loading && data ? data : [],
        refetch: fetchCustomMetadata,
      }}
    >
      {children}
    </CustomMetadataContext.Provider>
  )
}
